import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { url } from 'configs/';
const { NEWTUBE_API_SERVER } = url;


const FETCH_EMPLOYEE_DATA_REQUEST = 'foundation/hire/FETCH_FETCH_EMPLOYEE_DATA_REQUEST';
const FETCH_EMPLOYEE_DATA_SUCCESS = 'foundation/hire/FETCH_FETCH_EMPLOYEE_DATA_SUCCESS';
const FETCH_EMPLOYEE_DATA_FAIL = 'foundation/hire/FETCH_FETCH_EMPLOYEE_DATA_FAIL';

const POST_REGISTER_DATA_REQUEST = 'foundation/hire/POST_REGISTER_DATA_REQUEST';
const POST_REGISTER_DATA_SUCCESS = 'foundation/hire/POST_REGISTER_DATA_SUCCESS';
const POST_REGISTER_DATA_FAIL = 'foundation/hire/POST_REGISTER_DATA_FAIL';

const PUT_REGISTER_DATA_REQUEST = 'foundation/hire/PUT_REGISTER_DATA_REQUEST';
const PUT_REGISTER_DATA_SUCCESS = 'foundation/hire/PUT_REGISTER_DATA_SUCCESS';
const PUT_REGISTER_DATA_FAIL = 'foundation/hire/PUT_REGISTER_DATA_FAIL';

export default function reducer(state = {
  employeeData: {
    basicInfo: {},
    certificaties: [],
    contact: {},
    educationDatas: [],
    employeeInfo: {},
    seniorityInfo: {},
    workExperience: [],
  },
  page: {},
  isEmployeeLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_EMPLOYEE_DATA_REQUEST:
      return Object.assign({}, state, {
        isEmployeeLoading: true,
      });
    case FETCH_EMPLOYEE_DATA_SUCCESS:
      return Object.assign({}, state, {
        isEmployeeLoading: false,
        employeeData: action.response.data,
      });
    case FETCH_EMPLOYEE_DATA_FAIL:
      return Object.assign({}, state, {
        isEmployeeLoading: false,
      });
    default:
      return state;
  }
}

export function fetchEmployeeData(id) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `PA/HireList/${id}`,
      method: 'GET',
      types: [
        FETCH_EMPLOYEE_DATA_REQUEST,
        FETCH_EMPLOYEE_DATA_SUCCESS,
        FETCH_EMPLOYEE_DATA_FAIL,
      ],
    },
  };
}

export function postRegisterData(formData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `PA/HireList`,
      method: 'POST',
      types: [
        POST_REGISTER_DATA_REQUEST,
        POST_REGISTER_DATA_SUCCESS,
        POST_REGISTER_DATA_FAIL,
      ],
      params: formData,
      contentType: CONTENT_TYPE.FORM,
    },
  };
}

export function putRegisterData(formData, onboardingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `PA/HireList/` + onboardingId,
      method: 'PUT',
      types: [
        PUT_REGISTER_DATA_REQUEST,
        PUT_REGISTER_DATA_SUCCESS,
        PUT_REGISTER_DATA_FAIL,
      ],
      params: formData,
      contentType: CONTENT_TYPE.FORM,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/screens/PersonalConfirm/reducers/index.js
 **/